import useAuth from "./useAuth";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import axiosService from "../utils/axios";
import useRefreshToken from "./useRefreshToken";

const useLogout = () => {
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  const refresh = useRefreshToken();

  const LOGOUT_URL = "/contactcentre/auth/logout/";

  const logout_final = async () => {
    try {
      const new_access_token = await refresh();

      if (!new_access_token) {
          return;
      }

      const response = await axiosService.post(
        LOGOUT_URL,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${new_access_token}`,
          },
          withCredentials: true,
        }
      );

      // ✅ Logout ONLY if backend confirms success
      // alert(JSON.stringify(response))
    if (response.status === 200) {
      localStorage.setItem("IsLoggedIn", "false");
      localStorage.removeItem("onlineStatus");
      navigate("/login", { replace: true });
      // window.location.replace("/login");
    }else{
      // alert("error")
      Swal.fire({
        title: "Logout Failed",
        text: `Unable to Logout. Please try again`,
        icon: "warning",
        showConfirmButton: true
      });
    }
    
  } catch (err) {
    console.error("Logout failed:", err);
    // alert("error")
    Swal.fire({
        title: "Logout Failed",
        text: `Unable to Logout. Please try again`,
        icon: "warning",
        showConfirmButton: true
      });
    }
  };

  const logout = (type) => {
    if (type == "input") {
      console.log(type)
    }else if (type === "instant_logout") {
      console.log("Instant logout triggered"); // ✅ debug
      logout_final();
    }else {
      Swal.fire({
        title: "Are you sure to Logout?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Logout",
      }).then((result) => {
        if (result.isConfirmed) {
          logout_final();
        }
      });
    }
  };

  return logout;
};
export default useLogout;
